import styled from "styled-components";
import Breadcrumbs from "../../../../components/Breadcrumbs";
import React, {useContext, useEffect, useState} from "react";
// Don't import ReactStars directly - we're using dynamic import
import dynamic from 'next/dynamic';
import "react-multi-carousel/lib/styles.css";
import "react-image-gallery/styles/css/image-gallery.css";
import {IProductImage} from "../../../../interfaces/IProductImage";
import {dehydrate, QueryClient, useQuery} from '@tanstack/react-query';
import {useRouter} from "next/router";
// @ts-ignore
import Link from "next/link";
import ProductCTA from "../../../../components/product/ProductCTA";
import AccessoriesBox from "../../../../components/product/AccessoriesBox";
import {IProduct} from "../../../../interfaces/IProduct";
import Image from "next/legacy/image";
import {Col, Container, Row} from "react-bootstrap";
import ProductCarousel from "../../../../components/product/ProductCarousel";
import ProductSections from "../../../../components/product/ProductSections";
import {getNavPath} from "../../../../shared/navigateUtil";
import {useCountryLang} from "../../../../hooks/useCountryLang";
import {useMessages} from "../../../../hooks/useMessages";
import {IRelatedProducts} from "../../../../interfaces/IRelatedProducts";
import {scrollbarTrack} from "../../../../shared/mixins";
import {request} from "../../../../shared/httpInterceptor";
import {IBreadcrumb} from "../../../../interfaces/IBreadcrumb";
import PageHead from "../../../../components/PageHead";
import {useClientContext} from "../../../../hooks/useContext";
import {getHost, withServerSideProps} from "../../../../shared/withServerSideProps";
import {LoggedOutCartContext} from "../../../../contexts/LoggedOutCartContext";
import {useShoppingCart} from "../../../../hooks/useShoppingCart";
import {getTheme} from "../../../../shared/themeUtils";
import {IMediaItem} from "../../../../interfaces/IMediaItem";
import ReactPlayer from "react-player";
import ProductRelatedLinks from "../../../../components/product/ProductRelatedLinks";
import ProductVariant from "../../../../components/product/ProductVariant";
import {IProductVariants} from "../../../../interfaces/IProductVariant";
import {extractIdFromSSR, extractIdFromUrl} from "../../../../shared/utils";
import Badge from "../../../../components/Badge";
import Script from "next/script";
import {IProductPart} from "../../../../interfaces/IProductParts";
import {IMagazineEntry} from "../../../../interfaces/IMagazine";
import {useRecentlyViewedProducts} from "../../../../hooks/useRecentlyViewedProducts";
import NotFound from "../../../../components/NotFound";
import {NotFoundType} from "../../../../shared/enums";
import TitleArea from "../../../../components/TitleArea";
import parse from "html-react-parser";
import type {ReactStarsProps} from 'react-rating-stars-component';
import type {ReactImageGalleryProps} from 'react-image-gallery';

const Title = styled.div`
    margin: ${getTheme("space.2")} 0;

    &.preview-prod {
        color: ${getTheme("colors.textOrange")};
    }

    h1 {
        font-weight: normal;

        span {
            font-weight: bold;
        }
    }

    .rating {
        display: flex;
        align-items: center;
    }

    .reviews-count {
        color: ${getTheme("colors.secondaryFont")};
        position: relative;
        top: 2px;
        left: 8px;
    }

    .brand-section {
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        .brand-image {
            display: flex;
            align-items: center;
            cursor: pointer;
            margin-right: ${getTheme("space.2")};

            span {
                margin-left: ${getTheme("space.2")};
            }
        }
    }
`;

const PageContain = styled.div`
    margin: ${getTheme("space.2")} 0;
    min-height: 800px;

    .product-links {
        padding: ${getTheme("space.2")};
        margin: ${getTheme("space.2")} 0;
        border-radius: ${getTheme("borderRadius")};
        border: 1px solid ${getTheme("colors.border")};

        table tr td {
        }
    }

    .labels-section {
        opacity: .7;
        margin: 0 ${getTheme("space.2")};
        display: flex;
        align-items: center;

        .label {
            padding: 0 ${getTheme("space.1")};
            border-right: 1px solid ${getTheme("colors.border")};
            display: inline-block;

            .label-icon {
                margin-right: ${getTheme("space.1")};
                max-width: 25px;
            }

            &:last-of-type {
                border-right: none;
            }
        }
    }

    .video-contain {
        display: flex;
        justify-content: center;
        margin: ${getTheme("space.2")} 0;
    }
`;

const MobileAccessoriesCarousel = styled.div`
    .accessories-carousel {
        margin: ${getTheme("space.3")} 0 0 0;
        font-weight: bold;
    }
`;

const ProductImageGallery = styled.div`
    width: 100%;
    padding-right: ${getTheme("space.2")};

    .badge-overlay {
        background: ${getTheme("colors.accent")};
        color: ${getTheme("colors.white")};
        padding: 12px;
        font-size: ${getTheme("fontSizes.small")};
        border-radius: ${getTheme("space.3")};
        font-weight: bold;
        position: absolute;
        top: 0;
        left: 0;
    }

    .image-gallery {
        .image-gallery-slide-wrapper {
            height: 500px;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .image-gallery-image {
            max-width: 500px;
            max-height: 470px;
        }

        .fullscreen .image-gallery-image {
            max-width: 90vw;
            max-height: 90vh;
        }

        .image-gallery-slide-wrapper {
            border-bottom: 1px solid ${getTheme("colors.border")};
        }

        .image-gallery-left-nav .image-gallery-svg, .image-gallery-right-nav .image-gallery-svg {
            height: 50px;
            width: 30px;
        }

        .image-gallery-icon {
            filter: none;
            color: ${getTheme("colors.primary")};
        }

        .image-gallery-thumbnails-container {
            display: flex;
            justify-content: flex-start;

            .image-gallery-thumbnail {
                width: 100px;
                height: 100px;
                display: flex;
                justify-content: center;
                align-items: center;
                border: 1px solid ${getTheme("colors.border")};
                border-radius: ${getTheme("borderRadius")};
                margin-right: ${getTheme("space.1")};
                padding: 8px;

                .image-gallery-thumbnail-inner {
                    width: 90px;
                    height: 90px;

                    .image-gallery-thumbnail-image {
                        object-fit: contain;
                        width: 90px;
                        height: 90px;
                    }
                }
            }

            .image-gallery-thumbnail.active, .image-gallery-thumbnail:focus, .image-gallery-thumbnail:hover {
                border: 2px solid ${getTheme("colors.primary")};
            }
        }

        .image-gallery-content.fullscreen {
            background: #fff;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;

            .image-gallery-slide-wrapper {
                border: none;
            }

            .image-gallery-thumbnails-container {
                justify-content: center;
            }

            .image-gallery-thumbnails-wrapper.thumbnails-swipe-horizontal {
                position: absolute;
                bottom: 10px;
                left: 0;
                right: 0;
            }
        }
    }
`;

const CtaColumn = styled.div`
    margin-top: ${getTheme("space.2")};
    position: sticky;
    top: 96px;

    .price {
        text-align: center;
    }

    .stock-status {
        text-align: center;
        margin-top: ${getTheme("space.1")};
    }
`;

const Variants: any = styled.div`
    padding: ${getTheme("space.2")} 0;
    margin: ${getTheme("space.2")} 0 0;
    border-top: 1px solid ${getTheme("colors.border")};

    .rating-variation {
        display: flex;
        align-items: center;

        span.rating-count {
            margin-left: ${getTheme("space.1")};
        }
    }

    .section-title {
        font-size: ${getTheme("fontSizes.medium")};
        font-weight: bold;
        margin-bottom: ${getTheme("space.2")};
    }

    .contain-variants {
        max-height: 330px;
        overflow: auto;

        ${scrollbarTrack}
    }
`;

const EolCarouselSection = styled.div`
    margin-top: ${getTheme("space.4")};
    padding-bottom: ${getTheme("space.2")};
    border-bottom: 1px solid ${getTheme("colors.border")};

    .section-title {
        font-size: ${getTheme("fontSizes.large")};
        font-weight: bold;
        margin: ${getTheme("space.1")} 0;
    }
`

const EOLMessage = styled.div`
    text-align: center;
    margin: ${getTheme("space.3")} 0 ${getTheme("space.5")} 0;

    h1 {
        font-size: ${getTheme("fontSizes.large")};
        margin-bottom: ${getTheme("space.2")};
    }

    p {
        font-size: ${getTheme("fontSizes.medium")};
        line-height: 1.5;
        color: ${getTheme("colors.secondaryFont")};
    }

    strong {
        font-weight: bold;
    }
`;

const EmptyListing = styled.div`
    min-height: ${getTheme("space.6")};
    margin: auto;
    margin-bottom: ${getTheme("space.4")};
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    color: ${getTheme("colors.secondaryFont")};
    max-width: 1000px;
`

// Import ImageGallery dynamically with no SSR
const ImageGalleryClient = dynamic<ReactImageGalleryProps>(
  () => import('react-image-gallery').then((mod) => mod.default),
  {ssr: false}
);

// Placeholder component for SSR
const ImageGalleryPlaceholder = () => {
  return (
    <div
      style={{
        width: '100%',
        height: '500px',
        backgroundColor: '#f8f8f8',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '4px',
        marginBottom: '20px'
      }}
    ></div>
  );
};

// Import ReactStars dynamically with no SSR
const ReactStarsClient = dynamic<ReactStarsProps>(
  () => import('react-rating-stars-component').then((mod) => mod.default),
  {ssr: false}
);

// Placeholder for star ratings during SSR
const RatingPlaceholder = ({size = 20}: { size?: number }) => {
  return (
    <div
      style={{
        width: `${size * 5 + 10}px`,
        height: `${size}px`,
        backgroundColor: '#f0f0f0',
        borderRadius: '4px',
        display: 'inline-block'
      }}
    ></div>
  );
};

export const fetchProduct = async (productId: number | null, countryLang: string | null, host?: string, context?: any) => {
  try {
    const requestConfig: any = {
      url: `/${countryLang}/product/${productId}`,
      method: 'get',
      host: host
    };

    // Only add cookies and context if they exist
    if (context?.req?.cookies) {
      requestConfig.cookies = context.req.cookies;
    }
    if (context) {
      requestConfig.context = context;
    }

    const res = await request(requestConfig);
    return res.data;
  } catch (error) {
    console.error("Error fetching product:", error);
    throw error;
  }
}

const fetchProductBreadcrumbs = async (productId: number | null, countryLang: string | null, host?: string, context?: any) => {
  const requestConfig: any = {
    url: `/${countryLang}/product/breadcrumbs/${productId}`,
    method: 'get',
    host: host
  };

  if (context) {
    requestConfig.context = context;
  }

  const res = await request(requestConfig);
  return res.data;
}

const fetchProductAccessories = async (productId: number | null, countryLang: string | null, host?: string, context?: any) => {
  const requestConfig: any = {
    url: `/${countryLang}/product/${productId}/accessories`,
    method: 'get',
    host: host
  };

  if (context) {
    requestConfig.context = context;
  }

  const res = await request(requestConfig);
  return res.data;
}

const fetchProductVariants = async (productId: number | null, countryLang: string | null, host?: string, context?: any) => {
  const requestConfig: any = {
    url: `/${countryLang}/product/${productId}/variants`,
    method: 'get',
    host: host
  };

  if (context) {
    requestConfig.context = context;
  }

  const res = await request(requestConfig);
  return res.data;
}

const fetchRelatedProducts = async (productId: number | null, countryLang: string | null, host?: string, context?: any) => {
  const requestConfig: any = {
    url: `/${countryLang}/product/${productId}/related`,
    method: 'get',
    host: host
  };

  if (context) {
    requestConfig.context = context;
  }

  const res = await request(requestConfig);
  return res.data;
}

const fetchMainVideo = async (productId: number | null, countryLang: string | null, host?: string, context?: any) => {
  const requestConfig: any = {
    url: `/${countryLang}/product/${productId}/media/mainVideo`,
    method: 'GET',
    host: host
  };

  if (context) {
    requestConfig.context = context;
  }

  const res = await request(requestConfig);
  return res.data;
}


const fetchParts = async (productId: number | null, countryLang: string | null, host?: string, context?: any) => {
  const requestConfig: any = {
    url: `/${countryLang}/product/${productId}/parts`,
    method: 'get',
    host: host
  };

  if (context) {
    requestConfig.context = context;
  }

  const res = await request(requestConfig);
  return res.data;
}


const fetchSuppliedItems = async (productId: number | null, countryLang: string | null, host?: string, context?: any) => {
  const requestConfig: any = {
    url: `/${countryLang}/product/${productId}/suppliedText`,
    method: 'get',
    host: host
  };

  if (context) {
    requestConfig.context = context;
  }

  const res = await request(requestConfig);
  return res.data;
}


const fetchProductMagazineArticles = async (productId: number | null, countryLang: string | null, host?: string, context?: any) => {
  const requestConfig: any = {
    url: `/${countryLang}/product/${productId}/magazineArticles`,
    method: 'get',
    host: host
  };

  if (context) {
    requestConfig.context = context;
  }

  const res = await request(requestConfig);
  return res.data;
}


const fetchSuccessor = async (productId: number | null, countryLang: string | null, host?: string, context?: any) => {
  const requestConfig: any = {
    url: `/${countryLang}/product/${productId}/successor`,
    method: 'get',
    host: host
  };

  if (context) {
    requestConfig.context = context;
  }

  const res = await request(requestConfig);
  return res.data;
}


const fetchPredecessor = async (productId: number | null, countryLang: string | null, host?: string, context?: any) => {
  const requestConfig: any = {
    url: `/${countryLang}/product/${productId}/predecessor`,
    method: 'get',
    host: host
  };

  if (context) {
    requestConfig.context = context;
  }

  const res = await request(requestConfig);
  return res.data;
}


const fetchSets = async (productId: number | null, countryLang: string | null, host?: string, context?: any) => {
  const requestConfig: any = {
    url: `/${countryLang}/product/${productId}/sets`,
    method: 'get',
    host: host
  };

  if (context) {
    requestConfig.context = context;
  }

  const res = await request(requestConfig);
  return res.data;
}

type ProductPropsType = {
  product: IProduct,
  breadcrumbs: IBreadcrumb[],
  productId: number,
  countryLangProp: string
}

const Product = (props: ProductPropsType) => {
  const countryLangFromHook = useCountryLang();
  const countryLang = countryLangFromHook || props.countryLangProp;
  const router = useRouter();
  const [productId, setProductId] = useState<number | null>(props.productId || null);
  const [isClient, setIsClient] = useState(false);
  const contextQuery = useClientContext();
  const messagesQuery = useMessages();
  const {loggedOutCartCtx} = useContext(LoggedOutCartContext);
  const shoppingCartQuery = useShoppingCart();
  const [showCarouselThumbnails, setShowCarouselThumbnails] = useState(true);
  const {addProduct} = useRecentlyViewedProducts();

  useEffect(() => {
    setIsClient(true);
  }, []);

  useEffect(() => {
    if (!router.isReady) return;

    const id = extractIdFromUrl(router);
    setProductId(id);
  }, [router.isReady, router.asPath]);

  const productQuery = useQuery(["product", productId, countryLang],
    () => fetchProduct(productId, countryLang), {
      enabled: countryLang != null && productId != null && !isNaN(Number(productId)),
    });

  const breadcrumbsQuery = useQuery(["breadcrumbs", productId, countryLang],
    () => fetchProductBreadcrumbs(productId, countryLang), {
      enabled: countryLang != null && productId != null && (productQuery.data && (!productQuery.data.isEol && !productQuery.data.isAlternateEol)) && !isNaN(Number(productId)),
    });

  const productAccessoriesQuery = useQuery(["product-accessories", productId, countryLang],
    () => fetchProductAccessories(productId, countryLang), {
      enabled: countryLang != null && productId != null && (productQuery.data && !productQuery.data.isEol && !productQuery.data.isAlternateEol) && !isNaN(Number(productId)),
    });

  const relatedProductsQuery = useQuery<IRelatedProducts | void>(["related-products", productId, countryLang],
    () => fetchRelatedProducts(productId, countryLang), {
      enabled: countryLang != null && productId != null && (productQuery.data && !productQuery.data.isEol && !productQuery.data.isAlternateEol) && !isNaN(Number(productId)),
    });

  const variantsQuery = useQuery<IProductVariants>(["product-variants", productId, countryLang],
    () => fetchProductVariants(productId, countryLang), {
      enabled: countryLang != null && productId != null && (productQuery.data && !productQuery.data.isEol && !productQuery.data.isAlternateEol) && !isNaN(Number(productId)),
    });

  const partsSectionQuery = useQuery<IProductPart[]>(["product-parts", productId, countryLang],
    () => fetchParts(productId, countryLang), {
      enabled: countryLang != null && productId != null && (productQuery.data && !productQuery.data.isEol && !productQuery.data.isAlternateEol) && !isNaN(Number(productId)),
    });

  const mainVideoQuery = useQuery<IMediaItem[] | any>(["product-main-video", productId, countryLang],
    () => fetchMainVideo(productId, countryLang), {
      enabled: countryLang != null && productId != null && (productQuery.data && !productQuery.data.isEol && !productQuery.data.isAlternateEol) && !isNaN(Number(productId))
    });

  const suppliedItemsQuery = useQuery<string | null>(["supplied-items", productId, countryLang],
    () => fetchSuppliedItems(productId, countryLang), {
      enabled: countryLang != null && productId != null && (productQuery.data && !productQuery.data.isEol && !productQuery.data.isAlternateEol) && !isNaN(Number(productId)),
    });

  const productMagazineArticlesQuery = useQuery<IMagazineEntry[]>(["product-magazine-articles", productId, countryLang],
    () => fetchProductMagazineArticles(productId, countryLang), {
      enabled: countryLang != null && productId != null && (productQuery.data && !productQuery.data.isEol && !productQuery.data.isAlternateEol) && !isNaN(Number(productId)),
    });

  const successorQuery = useQuery<IMagazineEntry[]>(["successor-product", productId, countryLang],
    () => fetchSuccessor(productId, countryLang), {
      enabled: countryLang != null && productId != null && (productQuery.data && !productQuery.data.isEol && !productQuery.data.isAlternateEol) && !isNaN(Number(productId)),
    });

  const predecessorQuery = useQuery<IMagazineEntry[]>(["predecessor-product", productId, countryLang],
    () => fetchPredecessor(productId, countryLang), {
      enabled: countryLang != null && productId != null && (productQuery.data && !productQuery.data.isEol && !productQuery.data.isAlternateEol) && !isNaN(Number(productId)),
    });

  const setsQuery = useQuery<IProductPart[]>(["sets", productId, countryLang],
    () => fetchSets(productId, countryLang), {
      enabled: countryLang != null && productId != null && (productQuery.data && !productQuery.data.isEol && !productQuery.data.isAlternateEol) && !isNaN(Number(productId)),
    });

  // Check if product is in cart
  const isProductInCart = React.useMemo(() => {
    if (!productId || !isClient) return false;
    if (loggedOutCartCtx) {
      return loggedOutCartCtx.some(item => item.product.productID === productId);
    }
    if (shoppingCartQuery.data?.products) {
      return shoppingCartQuery.data.products.some(item => item.product.productID === productId);
    }
    return false;
  }, [productId, loggedOutCartCtx, shoppingCartQuery.data, isClient]);

  // Track recently viewed products
  useEffect(() => {
    if (isClient && productId && !isNaN(Number(productId)) && productQuery.data && !productQuery.data.isEol) {
      addProduct(productId);
    }
  }, [productId, productQuery.data?.isEol, addProduct, isClient]);

  const getImages = (): Array<any> => {
    const images: Array<any> = [];
    if (productQuery.data) {
      // Add main image
      if (productQuery.data.image?.imageUrl) {
        images.push({
          original: productQuery.data.image.imageUrl,
          thumbnail: productQuery.data.image.imageUrl,
          originalAlt: productQuery.data.brandAndProductName || 'Product image',
          thumbnailAlt: productQuery.data.brandAndProductName || 'Product thumbnail',
          piecesOfMainImage: productQuery.data.piecesOfMainImage
        });
      }

      // Add additional images
      productQuery.data.additionalImages?.forEach((img: IProductImage, index: number) => {
        if (img.imageUrl) {
          images.push({
            original: img.imageUrl,
            thumbnail: img.imageUrl,
            originalAlt: `${productQuery.data.brandAndProductName || 'Product'} - Image ${index + 2}`,
            thumbnailAlt: `${productQuery.data.brandAndProductName || 'Product'} - Thumbnail ${index + 2}`
          });
        }
      });
    }
    return images;
  };

  const renderBadgesOverlay = (item: any) => {
    if (!item || !item.original) {
      return null;
    }

    return (
      <div className="image-container">
        <img
          className="image-gallery-image"
          src={item.original}
          alt={item.originalAlt || ''}
          style={{
            maxWidth: '100%',
            maxHeight: '470px',
            width: 'auto',
            height: 'auto',
            objectFit: 'contain',
            display: 'block',
            margin: '0 auto'
          }}
        />
        {item.piecesOfMainImage && <span className="badge-overlay">{item.piecesOfMainImage}x</span>}
      </div>
    );
  };

  const getStockStatusSchema = (color: string | undefined) => {
    switch (color) {
      case "green":
        return "https://schema.org/InStock";
      case "orange":
        return "https://schema.org/BackOrder";
      default:
        return "https://schema.org/OutOfStock";
    }
  }

  // Prepare structured data object
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": productQuery.data?.brandAndProductName,
    "image": productQuery.data?.image?.imageUrl || null,
    "description": productQuery.data?.description,
    "sku": productQuery.data?.productID,
    "gtin": productQuery.data?.ean || null,
    "brand": {
      "@type": "Brand",
      "name": productQuery.data?.brand
    },
    "offers": {
      "@type": "Offer",
      "priceCurrency": productQuery.data?.currency,
      "price": productQuery.data?.price ? productQuery.data.price.toFixed(2) : null,
      "availability": getStockStatusSchema(productQuery.data?.stockDisplayColor),
      "url": isClient ? window.location.href : '',
      "shippingDetails": {
        "@type": "OfferShippingDetails",
        "shippingRate": {
          "@type": "MonetaryAmount",
          "value": productQuery.data?.shippingCostValue,
          "currency": productQuery.data?.currency
        }
      }
    }
  };

  // Conditionally add aggregateRating only if both ratingValue and reviewCount exist and are > 0
  if (productQuery.data?.overallReviewRating && 
      productQuery.data?.productReviewsCount && 
      productQuery.data.overallReviewRating > 0 && 
      productQuery.data.productReviewsCount > 0) {
    (structuredData as any).aggregateRating = {
      "@type": "AggregateRating",
      "ratingValue": productQuery.data.overallReviewRating,
      "reviewCount": productQuery.data.productReviewsCount
    };
  }

  // EOL Layout
  if (productQuery.data && (productQuery.data.isEol || productQuery.data.isAlternateEol)) {
    return (
      <div className="appContainer">
        <PageHead
          currentPageTitle={productQuery.data?.brandAndProductName || ''}
          description={productQuery.data?.properties || ''}
          canonical={typeof window !== 'undefined' ? window.location.href : ''}
          openGraph={{
            title: productQuery.data?.brandAndProductName || '',
            description: productQuery.data?.description || '',
            type: 'product',
            images: productQuery.data?.image ? [
              {
                url: productQuery.data.image.imageUrl,
                width: 400,
                height: 400,
                alt: productQuery.data.brandAndProductName,
              }
            ] : [],
            siteName: contextQuery.data?.platformName || '',
          }}
          meta={[
            {name: 'product:price:amount', content: productQuery.data?.price?.toString() || ''},
            {name: 'product:price:currency', content: productQuery.data?.currency || ''},
            {name: 'product:availability', content: getStockStatusSchema(productQuery.data?.stockDisplayColor)},
            {name: 'product:brand', content: productQuery.data?.brand || ''},
            {name: 'product:condition', content: 'new'},
            {property: 'product:sku', content: productQuery.data?.productID?.toString() || ''},
            {property: 'product:ean', content: productQuery.data?.ean || ''}
          ]}
        />

        <PageContain>
          {breadcrumbsQuery.data && <Breadcrumbs items={breadcrumbsQuery.data}/>}
          <TitleArea title={productQuery.data.title}/>
          <EOLMessage>
            <EmptyListing>
              <Image src="/icons/live-music.svg" width={150} height={200}/>
              <div>{parse(productQuery.data.text)}</div>
            </EmptyListing>
          </EOLMessage>

          {productQuery.data.topBrandSeriesProducts && productQuery.data.topBrandSeriesProducts.length > 0 &&
            <EolCarouselSection>
              <div className="section-title">{productQuery.data.brandSeriesTitle}</div>
              <ProductCarousel items={productQuery.data.topBrandSeriesProducts}/>
            </EolCarouselSection>
          }

          {productQuery.data.topCategoryProducts && productQuery.data.topCategoryProducts.length > 0 &&
            <EolCarouselSection>
              <div className="section-title">{productQuery.data.topCategoryTitle}</div>
              <ProductCarousel items={productQuery.data.topCategoryProducts}/>
            </EolCarouselSection>
          }
        </PageContain>
      </div>
    )
  }

  // Not Found Layout
  if (productQuery.data && productQuery.data.errorID) {
    return (
      <NotFound type={NotFoundType.PRODUCT}/>
    )
  }

  // Normal Layout
  return (
    <div className="appContainer">
      <PageHead
        currentPageTitle={productQuery.data?.brandAndProductName || ''}
        description={productQuery.data?.properties?.join(', ') || ''}
        canonical={isClient ? window.location.href : ''}
        openGraph={{
          title: productQuery.data?.brandAndProductName || '',
          description: productQuery.data?.description || '',
          type: 'product',
          images: productQuery.data?.image ? [
            {
              url: productQuery.data.image.imageUrl,
              width: 400,
              height: 400,
              alt: productQuery.data.brandAndProductName,
            }
          ] : [],
          siteName: contextQuery.data?.platformName || '',
        }}
        meta={[
          {name: 'product:price:amount', content: productQuery.data?.price?.toString() || ''},
          {name: 'product:price:currency', content: productQuery.data?.currency || ''},
          {name: 'product:availability', content: getStockStatusSchema(productQuery.data?.stockDisplayColor)},
          {name: 'product:brand', content: productQuery.data?.brand || ''},
          {name: 'product:condition', content: 'new'},
          {property: 'product:sku', content: productQuery.data?.productID?.toString() || ''},
          {property: 'product:ean', content: productQuery.data?.ean || ''}
        ]}
      />

      <PageContain>
        <Container fluid>
          {breadcrumbsQuery.data && <Breadcrumbs items={breadcrumbsQuery.data}/>}
          <Row>
            <Col lg={8} md={12}>
              <Title className={productQuery.data?.preview ? "preview-prod" : ""}>
                <h1>{productQuery.data?.brandAndProductName}</h1>
                {productQuery.data?.prodGrpName && <div className="prod-grp-name text-muted mb-3">
                  <span>{productQuery.data.prodGrpName}</span>
                </div>}
                <div className="brand-section">
                  {productQuery.data?.brandImage &&
                    <Link href={getNavPath(router, `brand/${productQuery.data.brandSlug}`)}>
                      <span className="brand-image">
                        <Image src={productQuery.data.brandImage} alt={productQuery.data.brand} width='100' height='60'
                               objectFit='contain'/>

                        {productQuery.data.productStatus &&
                          <Badge type={"warning"} size={"small"} text={productQuery.data.productStatus}/>
                        }
                      </span>
                    </Link>
                  }
                  <div className="text-muted small">
                    {(productQuery.data && productQuery.data.hasProductReviews) &&
                      <div className="rating">
                        {!isClient && <RatingPlaceholder size={20}/>}
                        {isClient &&
                          <ReactStarsClient
                            count={5}
                            size={20}
                            activeColor="#ffd700"
                            edit={false}
                            isHalf={true}
                            value={productQuery.data.overallReviewRating}
                          />
                        }
                        <span className="reviews-count">({productQuery.data.productReviewsCount})</span>
                      </div>
                    }
                  </div>

                  {productQuery.data?.productLabels && productQuery.data.productLabels.length > 0 &&
                    <div className="labels-section">
                      {productQuery.data.productLabels.map((label: {
                        id: string;
                        iconFilePath?: string;
                        text: string
                      }) => {
                        return (
                          <div className="label" key={label.id}>
                            {label.iconFilePath &&
                              <img src={label.iconFilePath}
                                   className="label-icon"
                                   alt={label.text}/>
                            }
                            <span className="label-text">{label.text}</span>
                          </div>
                        )
                      })}
                    </div>
                  }
                </div>
              </Title>

              {/*Images Carousel*/}
              <ProductImageGallery>
                {!isClient && <ImageGalleryPlaceholder/>}
                {isClient && productQuery.data &&
                  <ImageGalleryClient
                    items={getImages()}
                    onScreenChange={fullScreen => setShowCarouselThumbnails(!fullScreen)}
                    showThumbnails={getImages().length > 1 && showCarouselThumbnails}
                    showBullets={getImages().length > 1 && !showCarouselThumbnails}
                    renderItem={renderBadgesOverlay}
                  />
                }
              </ProductImageGallery>

              {/*Video*/}
              {isClient && mainVideoQuery.data && !mainVideoQuery.data.errorID &&
                <div className={"video-contain"}>
                  <ReactPlayer url={mainVideoQuery.data[0].externalUrl} width={"100%"}/>
                </div>
              }
            </Col>
            <Col lg={4} md={12}>
              <CtaColumn>
                {productQuery.data &&
                  <ProductCTA productInCart={isProductInCart} product={productQuery.data}/>}

                {productQuery.data && productQuery.data.productDetails &&
                  <div className="product-links">
                    <ProductRelatedLinks product={productQuery.data}/>
                  </div>
                }

                <div className="d-none d-lg-block">
                  {(productAccessoriesQuery.data && productAccessoriesQuery.data.length > 0) &&
                    <AccessoriesBox products={productAccessoriesQuery.data}/>}
                </div>
              </CtaColumn>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className="d-lg-none">
                {(productAccessoriesQuery.data && productAccessoriesQuery.data.length > 0) &&
                  <MobileAccessoriesCarousel>
                    <p className="accessories-carousel text-center">Recommended accessories</p>
                    <ProductCarousel items={productAccessoriesQuery.data}/>
                  </MobileAccessoriesCarousel>
                }
              </div>

              {(variantsQuery.data && variantsQuery.data.hasVariants) && productId != null && messagesQuery.data &&
                <Variants>
                  <div className="section-title">{messagesQuery.data.messages["alternatives"]}</div>
                  <Row className="contain-variants">
                    {variantsQuery.data.hasVariants && variantsQuery.data.variants.map(variant => {
                      return (
                        <ProductVariant key={variant.productId} variant={variant}
                                        selectedProductId={productId}/>
                      )
                    })}
                  </Row>
                </Variants>
              }

              {productQuery.data &&
                <ProductSections product={productQuery.data}
                                 partsSection={partsSectionQuery.data}
                                 suppliedItems={suppliedItemsQuery.data}
                                 magazineArticles={productMagazineArticlesQuery.data}
                                 successor={successorQuery.data}
                                 predecessor={predecessorQuery.data}
                                 sets={setsQuery.data}
                                 relatedProducts={relatedProductsQuery.data || null}/>
              }
            </Col>
          </Row>
        </Container>
      </PageContain>
      {productQuery.data &&
        <Script
          id="structured-data"
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(structuredData)
          }}
        />
      }
    </div>
  )
}

export const getServerSideProps = withServerSideProps(async (context: any) => {
  const {params} = context;
  const productId = extractIdFromSSR(params)
  const queryClient = new QueryClient();
  const countryLang = `${context.query.country}/${context.query.lang}`
  const host = getHost(context.req);

  // Get initial product data for props
  const product = productId ? await fetchProduct(productId, countryLang, host, context) : null;

  if (productId && !isNaN(productId) && product != null && product.productName != null && !product.isEol && !product.isAlternateEol) {
    // Prefetch all necessary data
    await Promise.all([
      // Main product data
      queryClient.prefetchQuery(["product", productId, countryLang],
        () => fetchProduct(productId, countryLang, host, context)),

      // Breadcrumbs
      queryClient.prefetchQuery(["breadcrumbs", productId, countryLang],
        () => fetchProductBreadcrumbs(productId, countryLang, host, context)),

      // Accessories
      queryClient.prefetchQuery(["product-accessories", productId, countryLang],
        () => fetchProductAccessories(productId, countryLang, host, context)),

      // Related products
      queryClient.prefetchQuery(["related-products", productId, countryLang],
        () => fetchRelatedProducts(productId, countryLang, host, context)),

      // Variants
      queryClient.prefetchQuery(["product-variants", productId, countryLang],
        () => fetchProductVariants(productId, countryLang, host, context)),

      // Parts
      queryClient.prefetchQuery(["product-parts", productId, countryLang],
        () => fetchParts(productId, countryLang, host, context)),

      // Main video
      queryClient.prefetchQuery(["product-main-video", productId, countryLang],
        () => fetchMainVideo(productId, countryLang, host, context)),

      // Supplied items
      queryClient.prefetchQuery(["supplied-items", productId, countryLang],
        () => fetchSuppliedItems(productId, countryLang, host, context)),

      // Magazine articles
      queryClient.prefetchQuery(["product-magazine-articles", productId, countryLang],
        () => fetchProductMagazineArticles(productId, countryLang, host, context)),

      // Successor/Predecessor
      queryClient.prefetchQuery(["successor-product", productId, countryLang],
        () => fetchSuccessor(productId, countryLang, host, context)),
      queryClient.prefetchQuery(["predecessor-product", productId, countryLang],
        () => fetchPredecessor(productId, countryLang, host, context)),

      // Sets
      queryClient.prefetchQuery(["sets", productId, countryLang],
        () => fetchSets(productId, countryLang, host, context))
    ]);
  }

  return {
    props: {
      dehydratedState: dehydrate(queryClient),
      product: product || null,
      productId: productId || null,
      countryLangProp: countryLang
    }
  }
});

export default Product;
